import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/CouponManagement";

class CouponService {
    create(data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}`,
            data, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    search(params, page) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/Search`, 
            {
                ...params,
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": false,
                    "targetPage": page,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    update(couponId, data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.put(`${BASIC_API}/${couponId}`,
            data, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    getDetails(couponId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.get(`${BASIC_API}/${couponId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    delete(couponId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.delete(`${BASIC_API}/${couponId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
}

const NewCouponService = new CouponService();
export default NewCouponService;